"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleReporter = void 0;
exports.ConsoleReporter = {
    record: (name, className, startStamp, endStamp, marker) => {
        console.log({
            name,
            className,
            startStamp,
            endStamp,
            marker: marker || '',
            duration: endStamp - startStamp,
        });
        return marker;
    },
};
//# sourceMappingURL=ConsoleReporter.js.map